
import { Collapse, Grid, Typography, useTheme } from "@mui/material";
import {  useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { RecipientTypeEnum } from "../../../common/enums/RecipientTypeEnum";
import { IFormUserRecipient } from "../../form-recipient-list/FormRecipientListUtils";


export type RecipientSummaryListItemProps = {
    item: IFormUserRecipient,
};

export function RecipientSummaryListItem({
    item,
}: RecipientSummaryListItemProps) {

    const [expanded, setExpanded] = useState(false);

    const theme = useTheme();

    const recipients = item.recipients.filter(o => o.selected);




    function toggleExpanded() {
        setExpanded(!expanded);
    }    

    function renderRecipients() {

        return recipients.map(o => {
            return (
                <Grid
                    key={o.id}
                    sx={{
                        paddingTop: `${theme.spacing(1)}!important`,
                        //padding: 1,
                          // backgroundColor: "custom.background.1",

                }}
                    size={{
                        xs: 2,
                        sm: 2,
                        md: 3
                    }}>
                    <Typography variant='body2' 
                        component='div'
                        noWrap={false}>
                        {`${RecipientTypeEnum[o.recipientType]}: ${o.to}`}
                    </Typography>
                </Grid>
            );});
    }
    
    return (
        <>
            <ListItemButton onClick={toggleExpanded}>
              <ListItemText primary={item.userName} />
              <ExpandMore sx={{
                          transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                          transition: theme.transitions.create('transform', {
                              duration: theme.transitions.duration.shortest,
                          })
                      }} />
            </ListItemButton>
            <Collapse in={expanded} timeout="auto" unmountOnExit>

                <ListItemText sx={{marginLeft: 1,
                      marginTop: 4,
                      marginRight: 2,
                      backgroundColor: "custom.background.1",
                      borderRadius: '3px'
                      
                      }}>

                      <Grid container 
                        spacing={{ xs: 3, md: 4 }} 
                        columns={{ xs: 2, sm: 4, md: 12}} 
                        sx={{
                            padding: 2
                        }}>
                      {
                          renderRecipients()
                      }
                      </Grid>


                </ListItemText>

            </Collapse>
        </>
    );
}
